<template>
  <!--listBody-->
  <div class="content">
    <div class="notice">
      <p>
        <i class="el-icon-info"></i>设置“栏目”可以让您的动态内容更好的分类呈现；栏目中没有任何动态时，该栏目将不会展现在小程序中。
      </p>
    </div>
    <div class="condition">
      <div class="other_wrap">
        <!--<el-button type="primary">编辑排序</el-button>-->
        <el-button type="primary" @click="addcolumn(0, null)" size="small">添加栏目</el-button>
      </div>
    </div>
    <div class="table_wrap">
      <el-table :data="programaList" style="width: 100%">
        <el-table-column prop="name" label="栏目名称"></el-table-column>
        <el-table-column prop="num" label="动态数量"></el-table-column>
        <el-table-column label="支持投放的动态类型">
          <template slot-scope="scope">
            <span v-if="scope.row.type==0">支持企业动态和个人动态</span>
            <span v-if="scope.row.type==1">仅支持企业动态</span>
            <span v-if="scope.row.type==2">仅支持个人动态</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="addcolumn(1, scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="detelFn(scope.row.name,scope.row.id, scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <addColumnDialog :visible.sync="addcolumndialog" :dialogType="dialogType" :dialogContent="dialogContent" v-if="addcolumndialog" @initFn="InitFn"></addColumnDialog>
  </div>
</template>
<script>
  import api from '@/api.js';
  import addColumnDialog from "@/components/dialog/addColumnDialog.vue";
  export default {
    name: "columnPannel",
    components: {
      addColumnDialog
    },
    data() {
      return {
        addcolumndialog: false,
        programaList: null,
        dialogType: 0,
        dialogContent: null
      };
    },
    created() {
      this.InitFn()
    },
    methods: {
      InitFn() {
        this.axios
          .post(api.programa_index, {})
          .then(response => {
            if (response.data.code == 0) {
              this.programaList = response.data.list
            } else {
            }
          })
          .catch(response => {
          });
      },
      // 添加栏目
      addcolumn(option,row) {
        // option 0 添加 1 编辑
        this.dialogType = option
        this.dialogContent = row
        this.addcolumndialog = true;
      },
      detelFn(name, id, index){
        let self_ = this
        this.$confirm('是否删除"'+name+'"栏目', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          closeOnClickModal: false
        }).then(() => {
          self_.axios
            .post(api.programa_delete, {pro_id:id})
            .then(response => {
              if (response.data.code == 0) {
                self_.programaList.splice(index, 1)
                self_.$message({
                  message: '删除成功!'
                });
              } else {
              }
            })
            .catch(response => {
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    }
  };
</script>
